import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import messages from "../messages";

function* getTeamUplineList(action) {
  const params = action.payload;
  const { success, data, error } = yield* makeRequest.get("/users/upline", params);
  if (success && data) {
    yield put(actions.setTeamUplineList(camelizeKeys(data.body)));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_FETCHING_TEAM_UPLINE_LIST,
    });
  }
  return null;
}

export default getTeamUplineList;
